module.exports = __webpack_public_path__ + "static/media/payment-icon.eb2723b1.svg";